import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformReferralInvitations } from './referral-invitations.transformers';
import type { ReferralInvitationsCollection } from './referral-invitations.types';

export function referralInvitationsReducer(
  state: CollectionStateSlice<ReferralInvitationsCollection> = {},
  action: CollectionActions<ReferralInvitationsCollection>,
): CollectionStateSlice<ReferralInvitationsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      const { result, ref, order } = action.payload;
      if (action.payload.type === 'referralInvitations') {
        return mergeDocuments<ReferralInvitationsCollection>(
          state,
          transformIntoDocuments(result, transformReferralInvitations),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'referralInvitations') {
        const { document, ref, rawRequest } = action.payload;
        return mergeWebsocketDocuments<ReferralInvitationsCollection>(
          state,
          transformIntoDocuments(
            [document],
            transformReferralInvitations,
            rawRequest,
          ),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
